import React, { Suspense, useState, useEffect, useRef } from "react";
import { Modal } from 'react-responsive-modal';
import TransactionServices from "../TransactionServices";
import Pagination from "components/Common/newPagination";
import ISRCMappingSelect from "./ISRCMappingSelection";
import DeleteDialogueBox from "components/Common/deleteDialogue";

export default function ISRCMappingBox(param: any) {
    console.log(param)

    let [deleteISRC, setdeleteISRC] = useState(false);
    let [isrcmapping, setIsrcmapping] = useState<any>([]);
    let [isrcformValid, setisrcformValid] = useState(false);
    let [deleteISRCselect, setdeleteISRCselect] = useState<any>([]);
    let [showSuccessSaveMsg, setshowSuccessSaveMsg] = useState(false);
    let [isrcMappingDetails, setisrcMappingDetails] = useState<any>([]);
    let [ISRCMappingSelectionType, setISRCMappingSelectionType] = useState("");
    let [ISRCMappingSelectionOpen, setISRCMappingSelectionOpen] = useState(false);

    useEffect(() => {
        TransactionServices.isrcmapping({}).then((respond: any) => {
            isrcmapping = respond;
            setIsrcmapping(isrcmapping)
        })
    }, []);

    const pagination = { pageNumber: 1, pageSize: 10, }
    const handleNameOnChange = (paginationEvent: any) => {
        pagination.pageNumber = paginationEvent.pageNumber;
        pagination.pageSize = paginationEvent.pageSize;
    }

    const ISRCMappingClose = () => { param.ISRCMappingClose(); }

    const clearSelectedRecord = () => {
        isrcMappingDetails = [];
        setisrcMappingDetails(isrcMappingDetails)
    }

    const addUpateRecord = () => {

        if (isrcMappingDetails?.newIsrcCode) {

            var payload = {
                isrcupcId: isrcMappingDetails?.isrcupcId ?? 0, newIsrcCode: isrcMappingDetails?.newIsrcCode,
                onUpcCode: isrcMappingDetails?.onUpcCode, repIsrcCode: isrcMappingDetails?.repIsrcCode
            }

            TransactionServices.isrcmappingSave(payload)
        }
    }

    const editRecord = (e: any) => {
        isrcMappingDetails = e;
        setisrcMappingDetails(isrcMappingDetails)
    }

    const removeRecord = (e: any) => {
        deleteISRC = e;
        setdeleteISRC(deleteISRC)

        deleteISRCselect = e;
        setdeleteISRCselect(deleteISRCselect)
    }

    const updateFactSalesData = (e: any) => { TransactionServices.isrcmappingfactsalesdata({}) }

    const ISRCMappingSelection = (eventNumber: any) => {
        ISRCMappingSelectionType = eventNumber;
        setISRCMappingSelectionType(ISRCMappingSelectionType)

        ISRCMappingSelectionOpen = true;
        setISRCMappingSelectionOpen(ISRCMappingSelectionOpen)
    }

    const ISRCMappingSelectionClose = (e: any) => {
        console.log(e)
        if (e && Number(ISRCMappingSelectionType) == 0) {
            setisrcMappingDetails({ ...isrcMappingDetails, newIsrcCode: e?.intStdRecCode })
        }

        if (e && Number(ISRCMappingSelectionType) == 1) {
            setisrcMappingDetails({ ...isrcMappingDetails, repIsrcCode: e?.intStdRecCode })

        }

        ISRCMappingSelectionOpen = false;
        setISRCMappingSelectionOpen(ISRCMappingSelectionOpen)
    }

    const deleteConfirmation = (e: any) => {
        console.log(e)

        //e==1 YES 
        if (e == 1) {
            TransactionServices.isrcmappingDelete(deleteISRCselect.isrcupcId)
        }
        //e==2 NO
        deleteISRC = false;
        setdeleteISRC(deleteISRC)
    }

    return (
        <div className="ws-6">

            <Modal open={param.param} onClose={ISRCMappingClose} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-7 paddingCenterBox bgTransparent' }} >

                <div className="ws-12 box">
                    <div className="box-header-main">  <h2 > ISRC Mapping</h2>  </div>

                    <div className="ws-12 box pm">
                        {showSuccessSaveMsg && <div className="alert alert-success">ISRC saved successfully</div>}

                        {isrcformValid && <div className="alert alert-danger">There was a problem submitting your request, one or more fields are missing or incorrect.</div>}

                        <div className="form-format ws-12 m0">
                            <label className="control-label ws-2 ">Current ISRC</label>
                            <div className="label-entries ml">
                                <div className="ws-6">
                                    <input readOnly name="isrcfield" className="ws-12 text-uppercase" placeholder="ISRC" value={isrcMappingDetails?.repIsrcCode ?? ""} required />
                                </div>

                                <div className="ws-4">
                                    <button type="button" className="icon-btn primary " onClick={() => ISRCMappingSelection(1)}>
                                        <i className="icon-qrcode"></i> Choose ISRC
                                    </button>
                                </div>
                            </div>

                        </div>

                        <div className="form-format ws-12 m0 mt">
                            <label className="control-label ws-2 ">ISRC Should Be</label>

                            <div className="label-entries ml">
                                <div className="ws-6">
                                    <input readOnly type="text" name="isrcshouldbe" className="form-control text-uppercase ws-12" placeholder="ISRC" value={isrcMappingDetails?.newIsrcCode ?? ""} />
                                </div>

                                <div className="ws-4">
                                    <button type="button" className="icon-btn primary " onClick={() => ISRCMappingSelection(0)}>
                                        <i className="icon-qrcode"></i> Choose ISRC
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="form-format ws-12 m0">
                            <label className="control-label ">On UPC</label>
                            <div className="label-entries ml">
                                <div className="ws-6">
                                    <input type="text" name="onupc" className="ws-12" placeholder="UPC" value={isrcMappingDetails?.onUpcCode ?? ""} onChange={(e: any) => setisrcMappingDetails({ ...isrcMappingDetails, onUpcCode: e.target.value })} required />
                                </div>
                            </div>
                        </div>

                        <div className="box-footer pull-right">
                            <button className="btn icon-btn edit btn-sm width100" onClick={addUpateRecord}><i className="icon-save"></i> Save  </button>
                            <button className="icon-btn delete btn-sm width100" onClick={clearSelectedRecord}> <i className="icon-reload"></i> Reset </button>
                        </div>

                    </div>

                    <div className="ws-12 box">
                        <div className="box-header well">
                            <h2 ><i className="icon-info"></i> {isrcmapping.length} record(s) found</h2>
                        </div>

                        {isrcmapping.length == 0 && <div className="alert alert-info mt mr ml ">No ISRC mapped yet </div>}

                        {isrcmapping.length > 0 && <div className="box-content">

                            <div className="table-responsive_big mt">
                                <table className="newTable">
                                    <thead>
                                        <tr>
                                            <th >ISRC Reported</th>
                                            <th >ISRC Should be</th>
                                            <th >Track Artist</th>
                                            <th >Track Title</th>
                                            <th >UPC</th>
                                            <th >Release Artist</th>
                                            <th >Release Title</th>
                                            <th >Operations</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {
                                            isrcmapping?.map((value: any) => {
                                                return (
                                                    <tr >
                                                        <td >{value?.repIsrcCode}</td>
                                                        <td >{value?.newIsrcCode}</td>
                                                        <td >{value?.newTrackArtist}</td>
                                                        <td >{value?.newTrackTitle}</td>
                                                        <td >{value?.onUpcCode}</td>
                                                        <td >{value?.releaseArtist}</td>
                                                        <td >{value?.releaseTitle}</td>
                                                        <td>
                                                            <button className="icon-btn edit" onClick={() => editRecord(value)}><i className="icon-edit-pencil"></i>  </button>
                                                            <button className="icon-btn delete" onClick={() => removeRecord(value)}><i className="icon-trashcan"></i>  </button>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }

                                    </tbody>
                                </table>

                                <div className="clearfix mt">
                                    {(() => {
                                        if (isrcmapping.length && isrcmapping.length > 10) {
                                            return <Pagination onPageChange={handleNameOnChange} totalRow={isrcmapping.length} />
                                        }
                                    })()}
                                </div>
                            </div>

                        </div>}

                    </div>

                    <div className="box-footer pull-right">
                        <button className="icon-btn delete btn-sm width100" onClick={ISRCMappingClose}>Close  </button>
                        <button className="icon-btn edit btn-sm width100" onClick={updateFactSalesData}>Update Data </button>
                    </div>
                </div>

                {(() => {
                    if (ISRCMappingSelectionOpen) {
                        return <ISRCMappingSelect ISRCMappingSelectionOpen={ISRCMappingSelectionOpen} ISRCMappingSelectionClose={ISRCMappingSelectionClose} />
                    }
                    if (deleteISRC) {
                        return <DeleteDialogueBox param={true} message={"delete the selected ISRC"} onChange={deleteConfirmation} />
                    }

                })()}

            </Modal>

        </div>
    )
}